import { render, staticRenderFns } from "./valmistumispyynto.vue?vue&type=template&id=7decf5a7&scoped=true&"
import script from "./valmistumispyynto.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynto.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynto.vue?vue&type=style&index=0&id=7decf5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7decf5a7",
  null
  
)

export default component.exports